/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type TimeSlotPickerCalendarAvailableTimeSlotsQueryVariables = Exact<{
  calendarGuid: string | number;
  from: TimeString;
  until: TimeString;
}>;


export type TimeSlotPickerCalendarAvailableTimeSlotsQuery = { calendarDetail:
    | { __typename: 'CalendarDetailNotFound' }
    | { __typename: 'CalendarDetailPermissionDenied' }
    | { __typename: 'CalendarDetailSuccess', calendar: { availableTimeSlots:
          | { __typename: 'AvailableTimeSlotsErrorNotAvailable', message: string }
          | { __typename: 'AvailableTimeSlotsSuccess', timeSlots: Array<{ startsAt: TimeString, endsAt: TimeString }> }
         } }
   };


export const TimeSlotPickerCalendarAvailableTimeSlotsDocument = gql`
    query TimeSlotPickerCalendarAvailableTimeSlots($calendarGuid: ID!, $from: Time!, $until: Time!) {
  calendarDetail(guid: $calendarGuid) {
    __typename
    ... on CalendarDetailSuccess {
      calendar {
        availableTimeSlots(from: $from, until: $until) {
          __typename
          ... on AvailableTimeSlotsSuccess {
            timeSlots {
              startsAt
              endsAt
            }
          }
          ... on AvailableTimeSlotsErrorNotAvailable {
            message
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTimeSlotPickerCalendarAvailableTimeSlotsQuery__
 *
 * To run a query within a Vue component, call `useTimeSlotPickerCalendarAvailableTimeSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeSlotPickerCalendarAvailableTimeSlotsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTimeSlotPickerCalendarAvailableTimeSlotsQuery({
 *   calendarGuid: // value for 'calendarGuid'
 *   from: // value for 'from'
 *   until: // value for 'until'
 * });
 */
export function useTimeSlotPickerCalendarAvailableTimeSlotsQuery(variables: TimeSlotPickerCalendarAvailableTimeSlotsQueryVariables | VueCompositionApi.Ref<TimeSlotPickerCalendarAvailableTimeSlotsQueryVariables> | ReactiveFunction<TimeSlotPickerCalendarAvailableTimeSlotsQueryVariables>, options: VueApolloComposable.UseQueryOptions<TimeSlotPickerCalendarAvailableTimeSlotsQuery, TimeSlotPickerCalendarAvailableTimeSlotsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeSlotPickerCalendarAvailableTimeSlotsQuery, TimeSlotPickerCalendarAvailableTimeSlotsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeSlotPickerCalendarAvailableTimeSlotsQuery, TimeSlotPickerCalendarAvailableTimeSlotsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TimeSlotPickerCalendarAvailableTimeSlotsQuery, TimeSlotPickerCalendarAvailableTimeSlotsQueryVariables>(TimeSlotPickerCalendarAvailableTimeSlotsDocument, variables, options);
}
export function useTimeSlotPickerCalendarAvailableTimeSlotsLazyQuery(variables?: TimeSlotPickerCalendarAvailableTimeSlotsQueryVariables | VueCompositionApi.Ref<TimeSlotPickerCalendarAvailableTimeSlotsQueryVariables> | ReactiveFunction<TimeSlotPickerCalendarAvailableTimeSlotsQueryVariables>, options: VueApolloComposable.UseQueryOptions<TimeSlotPickerCalendarAvailableTimeSlotsQuery, TimeSlotPickerCalendarAvailableTimeSlotsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeSlotPickerCalendarAvailableTimeSlotsQuery, TimeSlotPickerCalendarAvailableTimeSlotsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeSlotPickerCalendarAvailableTimeSlotsQuery, TimeSlotPickerCalendarAvailableTimeSlotsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TimeSlotPickerCalendarAvailableTimeSlotsQuery, TimeSlotPickerCalendarAvailableTimeSlotsQueryVariables>(TimeSlotPickerCalendarAvailableTimeSlotsDocument, variables, options);
}
export type TimeSlotPickerCalendarAvailableTimeSlotsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TimeSlotPickerCalendarAvailableTimeSlotsQuery, TimeSlotPickerCalendarAvailableTimeSlotsQueryVariables>;